import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCaptionsFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaptionsFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '32ec0a4c9b4ebc5ae6f78226e2296d1f9bc15ea0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7d7c929bb5789417e59f271c83de9b8f0e657464', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '758ff668c167e72cceeca6180285229a8f96c32c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 4h-17c-.276 0-.5.241-.5.538v12.924c0 .297.224.538.5.538h17c.276 0 .5-.241.5-.538V4.538c0-.297-.224-.538-.5-.538m-1 1.5v11h-15v-11zm-14 10v-9h13v9zm4.06-3.523a.87.87 0 0 0 .754-.403.28.28 0 0 1 .242-.158h.763c.138 0 .205.088.173.202a1.856 1.856 0 0 1-1.924 1.377 1.96 1.96 0 0 1-1.787-.967 2.02 2.02 0 0 1 0-2.056 1.96 1.96 0 0 1 1.787-.967 1.87 1.87 0 0 1 1.924 1.333c.027.114-.035.201-.173.201h-.777a.28.28 0 0 1-.235-.14.87.87 0 0 0-.744-.377.9.9 0 0 0-.665.285.92.92 0 0 0-.246.688.93.93 0 0 0 .243.693.9.9 0 0 0 .665.289m5 0h-.001.003zm.754-.403a.87.87 0 0 1-.754.403.9.9 0 0 1-.667-.287.92.92 0 0 1-.244-.695.92.92 0 0 1 .246-.688.9.9 0 0 1 .664-.285.87.87 0 0 1 .746.377c.05.084.137.137.234.14h.78c.139 0 .2-.087.174-.201a1.87 1.87 0 0 0-1.925-1.333 1.96 1.96 0 0 0-1.787.967 2.02 2.02 0 0 0 0 2.056 1.96 1.96 0 0 0 1.787.967c.883.066 1.69-.51 1.925-1.377.03-.114-.035-.202-.174-.202h-.763a.27.27 0 0 0-.242.158", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-captions-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-captions-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-captions-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaptionsFilled$1);
            }
            break;
    } });
}

const CosmosIconCaptionsFilled = CosmosIconCaptionsFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaptionsFilled, defineCustomElement };
